import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ClauseVarianceDetailedExportFilters {
  clauseName: string | null;
  targetDocumentId: string | null;
  legalEquivalence: string | null;
}

export interface ClauseVarianceDetailedExportRow {
  id: string;
  clauseId: number;
  clauseName: string;
  targetDocumentId: string;
  targetDocumentName: string;
  targetClause: string;
  page: string;
  legalEquivalence: string;
  legalDifferences: string;
  legalConsequences: string;
}

export interface ClauseVarianceDetailedExportState {
  initialized: boolean;
  allRows: ClauseVarianceDetailedExportRow[];
  filteredRows: ClauseVarianceDetailedExportRow[];
  filters: ClauseVarianceDetailedExportFilters;
}

@Injectable({
  providedIn: 'root',
})
export class ClauseVarianceExportStateService {
  private readonly detailedExportState$ =
    new BehaviorSubject<ClauseVarianceDetailedExportState>(this.getInitialState());

  setDetailedRows(
    allRows: ClauseVarianceDetailedExportRow[],
    filteredRows: ClauseVarianceDetailedExportRow[],
    filters: ClauseVarianceDetailedExportFilters,
  ): void {
    this.detailedExportState$.next({
      initialized: true,
      allRows,
      filteredRows,
      filters,
    });
  }

  getDetailedExportStateSnapshot(): ClauseVarianceDetailedExportState {
    return this.detailedExportState$.value;
  }

  private getInitialState(): ClauseVarianceDetailedExportState {
    return {
      initialized: false,
      allRows: [],
      filteredRows: [],
      filters: {
        clauseName: null,
        targetDocumentId: null,
        legalEquivalence: null,
      },
    };
  }
}
